import { apiRequest } from "@core/services/api/apiRequest";

export type UploadInfo = {
  s3_key: string;
  presigned_url: string;
};

export type UploadMetadata = {
  file_type?: string;
  organization_id?: number;
  alt_text?: string;
};

export async function completeDirectUpload(
  uploadInfo: UploadInfo,
  file: File,
  metadata: UploadMetadata = {}
) {
  const payload = {
    s3_key: uploadInfo.s3_key,
    file_name: file.name,
    file_size: file.size,
    file_type: metadata.file_type || "document",
    organization_id: metadata.organization_id,
    alt_text: metadata.alt_text || "",
  };

  const response = await apiRequest(
    "/uploads/complete/",
    "POST",
    payload,
    true
  );

  return response;
}

export default completeDirectUpload;

